export function previewFormat(path) {
  let previewPath = path;
  if (previewPath && previewPath !== '/' && path.charAt(0) === '/') {
    previewPath = path.substring(1);
  }

  return previewPath;
}

export function previewPath(path) {
  return `/preview?path=${previewFormat(path)}`;
}

export function formatPath(path) {
  let link = path;
  if (path.charAt(0) !== '/') {
    link = `/${path}`;
  }

  return link;
}
